import { Component, OnInit } from "@angular/core";
import { OAuthService } from "@santander/security-angular";

@Component({
    selector: "prescp-oauth-init",
    template: ""
})
export class OAuthInitComponent implements OnInit {

  constructor(private readonly oauthService: OAuthService) {}

  ngOnInit(): void {
    // Initializes SCM library: sets up PKCE (codeVerifier) and redirects
    // to the authorization_endpoint configured in config.json.
    // In deployed environments, the authorization_endpoint redirects back to /login.
    (this.oauthService as any).init();
  }
}
